export default __webpack_public_path__ + "static/media/bootstrap.eada9996.svg";